"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombineDialogShipment = void 0;
var _mui = require("@ori-ui/mui");
var _basketItem = require("@ori/basket-item");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CombineDialogShipment = ({
  subscriptions
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    culture,
    timeZone
  } = (0, _culture.useCulture)();
  const shipmentDate = subscriptions[0]?.nextShipment;
  const {
    basketItemTranslations,
    basketItemTranslationsNamespace
  } = (0, _contexts.useBasketContext)();
  if (!Object.keys(subscriptions).length || !shipmentDate) {
    return null;
  }
  const formattedNextShipment = (0, _culture.formatDate)(shipmentDate, _culture.DateFormat.MonthDay, culture, timeZone);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubscriptionShipment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_basketItem.BasketSection, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        children: `${formatMessage('nextShipment')}, ${formattedNextShipment}`
      }), subscriptions.map(subscription => {
        const {
          personalSubscriptionId,
          frequency,
          product: {
            concept: {
              brand,
              name
            } = {},
            formattedPrice: {
              price: {
                basicCataloguePrice,
                currentPrice
              } = {}
            } = {
              price: {}
            },
            imageUrl,
            productCode
          } = {}
        } = subscription;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_basketItem.BasketItem, {
          isAvailable: true,
          hideActionSection: true,
          name: name ?? '',
          cataloguePrice: basicCataloguePrice ?? '',
          bp: "0" // Will be connected after GQL integration
          ,

          testId: getTestId('combine-dialog-item'),
          brand: brand?.name ?? '',
          code: productCode ?? '',
          quantity: 1,
          maxQuantity: 1,
          image: imageUrl,
          totalPrice: currentPrice ?? '',
          infoAddon: formatMessage('everyXweeks', {
            frequency: frequency / 7
          }),
          type: "subscription",
          lineNumber: Number(personalSubscriptionId),
          translations: basketItemTranslations,
          translationsNamespace: basketItemTranslationsNamespace
        }, personalSubscriptionId);
      })]
    }, formattedNextShipment)
  }, formattedNextShipment);
};
exports.CombineDialogShipment = CombineDialogShipment;